<template>
  <div class="MultipleLine-container">
    <div :ref="chartid" class="chart-div"></div>
  </div>
</template>
<script>
import { getSize } from '@/utils/utils'
import {
  buildVisualReportGrid,
  buildVisualReportDataZoom,
  buildAxisTooltipPosition
} from '@/view/biketable/bikeriding/visualReportChartOptions.js'
export default {
  name: 'MultipleLine',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartid: {
      type: String,
      default: 'lineTwoChart'
    }
  },
  data () {
    return {
      lineChart: null,
      labes: [],
      vals: [],
      legends: []
    }
  },
  computed: {},
  created () {
    window.addEventListener('resize', this.chartResize)
  },
  mounted () {
    this.lineChart = this.$echarts.init(this.$refs[this.chartid], null, { renderer: 'svg' })
    this.lineChart.getZr().on('click', params => {
      if (this.labes.length) {
        const pointInPixel = [params.offsetX, params.offsetY]
        if (this.lineChart.containPixel('grid', pointInPixel)) {
          const pointInGrid = this.lineChart.convertFromPixel(
            {
              seriesIndex: 0
            },
            pointInPixel
          )
          const yIndex = pointInGrid[0]
          console.log('params=====', yIndex)
          this.$emit('updateSelect', yIndex)
          // this.$emit('change', yIndex)
          // if (this.charoption.click.canclick) {
          //   this.isStart = false
          //   this.$nextTick(() => {
          //     this.setOptions(this.labels, this.vals)
          //   })
          // }
        }
      }
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
  },
  methods: {
    chartResize () {
      if (this.lineChart) {
        setTimeout(() => {
          this.lineChart.resize()
          this.setOptions(this.labes, this.vals, this.legends)
        }, 10)
      }
    },
    setOptions (labes, vals, legends) {
      this.labes = labes
      this.vals = vals
      this.legends = legends
      var series = []
      const dataZoom = buildVisualReportDataZoom()
      this.vals.map((item, index) => {
        var obj = { name: this.legends[index], yAxisIndex: 0, data: item, symbolSize: 5, symbol: 'none', type: 'line' }
        series.push(obj)
      })
      const option = {
        title: { text: '', left: '45%' },
        // color: ['#5a7ff1', '#42bf7c'],
        grid: buildVisualReportGrid(),
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: buildAxisTooltipPosition()
        },
        legend: {
          data: this.legend,
          top: getSize(30),
          orient: 'horizontal',
          type: 'scroll'
        },
        dataZoom: dataZoom,
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.labes
        },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: series
      }
      this.lineChart.setOption(option, true)
    }
  }
}
</script>
<style scoped lang="scss">
.MultipleLine-container {
  width: 100%;
  height: 100%;
  position: relative;

  .chart-div {
    width: 100%;
    height: 100%;
  }
}
</style>
